import script from "./HealthQuestionnaireForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./HealthQuestionnaireForm.vue?vue&type=script&setup=true&lang=ts"

import "./HealthQuestionnaireForm.vue?vue&type=style&index=0&id=7b5a7e0b&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b5a7e0b"]])

export default __exports__